import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["notes"]

  async submitWithNotes(event) {
    event.preventDefault()

    const button = event.currentTarget

    // Same double-submit guard as approval_submit_controller: without it, three
    // clicks on Approve become three approvals.
    if (button.disabled) {
      return
    }

    const notesValue = this.notesTarget.value.trim()

    // Find the form dynamically - it's the parent of the button
    const form = button.closest("form")
    if (!form) {
      return
    }

    // Determine if notes are required based on button target
    let requiresNotes = false
    if (button.dataset.approvalActionsTarget === "rejectBtn") {
      requiresNotes = true
    } else if (button.dataset.approvalActionsTarget === "returnBtn") {
      requiresNotes = true
    }

    // Validate notes for reject and return actions
    if (requiresNotes && notesValue === "") {
      this.notesTarget.classList.add("is-invalid")
      this.showValidationError()
      return
    }

    // Remove validation error if present
    this.notesTarget.classList.remove("is-invalid")
    this.hideValidationError()

    // Submit using @rails/request.js to ensure Turbo Stream response
    const formData = new FormData()
    formData.append("notes", notesValue)

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      formData.append("authenticity_token", csrfToken)
    }

    // Send POST request with Turbo Stream accept header
    button.disabled = true
    try {
      const response = await post(form.action, {
        body: formData,
        responseKind: "turbo-stream"
      })

      if (!response.ok) {
        this.showErrorNotification("Approval action failed. Please try again.")
      }
    } catch (_error) {
      this.showErrorNotification("Network error. Please check your connection.")
    } finally {
      // The tab pane is replaced on success, so this usually targets a detached
      // node; on failure it hands the button back to the user.
      button.disabled = false
    }
  }

  showErrorNotification(message) {
    // Show error notification using existing toast/flash system if available
    const flashContainer = document.querySelector(".flash-messages")
    if (flashContainer) {
      const alert = document.createElement("div")
      alert.className = "alert alert-danger alert-dismissible fade show"
      const escapedMessage = this.escapeHtml(message)
      alert.innerHTML = `${escapedMessage}<button type="button" class="btn-close" data-bs-dismiss="alert"></button>`
      flashContainer.appendChild(alert)
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  showValidationError() {
    let error = this.notesTarget.parentElement.querySelector(".invalid-feedback")
    if (!error) {
      error = document.createElement("div")
      error.className = "invalid-feedback"
      error.textContent = this.notesTarget.dataset.errorMessage || "Note is required for this action"
      this.notesTarget.parentElement.appendChild(error)
    }
    error.style.display = "block"
  }

  hideValidationError() {
    const error = this.notesTarget.parentElement.querySelector(".invalid-feedback")
    if (error) {
      error.style.display = "none"
    }
  }
}
